// extracted by mini-css-extract-plugin
export default {"container":"w2Bhl dialog-content","tablist":"PPOGv","tab":"zOuI8","active":"vYy9j","name":"vxx33","form":"Q3J6E"};